/* Styled Components are hard code they will get from server once integrated */
import styled from "styled-components";
import { shadowStyled } from "../../styles/shared-styles";

export const LayoutLeftArrow = styled.div`
  width: 5%;
  height: 10%;
  ${props => props.theme.locale.dir !== "rtl" ?  '' : 'margin-right: 0%;'}
  position: absolute;
  z-index: 15;
  display:none;
`;

export const LayoutRightArrow = styled.div`
  width: 5%;
  height: 10%;
  ${props => props.theme.locale.dir !== "rtl" ?  'margin-left: 92%;' : 'margin-right: 95%;'}
  z-index: 15;
  position: absolute;
  display:none;
`;

export const  LeftArrow = styled.svg.attrs(props => ({
  viewBox: props.theme.components.icon.viewBox
}))`
  width: 2.5em;
  height: 3.5em;
  position: absolute;
  margin-top: 1.5em;
  z-index: 25;
  &:hover {
    
  }
`;

export const FillBtnLeftArrow = styled.path.attrs(props => ({
  d: props.theme.components.icon.list[props.theme.locale.dir !== "rtl" ? "arrowLeft" : "arrowRight" ].path
}))`
  fill: ${props => props.theme.color.primary};
  fill-opacity: 1;
  z-index:15;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const  RightArrow = styled.svg.attrs(props => ({
  viewBox: props.theme.components.icon.viewBox
}))`
  width: 2.5em;
  height: 3.5em;
  position: absolute;
  margin-top: 1.5em;
  ${props => props.theme.locale.dir !== "rtl" ?  'margin-left: 5em;' : 'margin-right: 2.25em;'}
  z-index: 25;
  &:hover {
   
  }
`;

export const FillBtnRightArrow = styled.path.attrs(props => ({
  d: props.theme.components.icon.list[props.theme.locale.dir !== "rtl" ? "arrowRight" : "arrowLeft"].path
}))`
  fill: ${props => props.theme.color.primary};
  fill-opacity: 1;
  z-index:15;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

/* TODO: review this shadow in the new Header + Layout + carousel refactorization */
/* prettier-ignore */
export const ShadowLayoutStyledLeft = styled.div`
 background-color : rgb(${props => props.theme.backgroundRGB});
 opacity:0.6;
 width: 7em;
 height: 6.75em;
 position:absolute;
`;

/* TODO: review this shadow in the new Header + Layout + carousel refactorization */
/* prettier-ignore */
export const ShadowLayoutStyledRight = styled.div`
background-color : rgb(${props => props.theme.backgroundRGB});
opacity: 0.6;
width: 7em;
${props => props.theme.locale.dir !== "rtl" ?  'margin-left: 1.25em;' : 'margin-right: -2.25em;'}
height: 6.75em;
position: absolute;
`;
